import React, {useRef, useState} from 'react';
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Card} from "primereact/card";

const MultiFileUploader = (props) => {
    const {name, label, onUpload, accept, note} = props;
    const [files, setFiles] = useState([]);
    const refUploadInput = useRef(null);

    const handleUploadFile = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        setFiles(selectedFiles);
        onUpload(selectedFiles);
        // Reset input
        event.target.value = null;
    };

    const removeFile = (index) => {
        const updatedFiles = files.filter((_, i) => i !== index);
        setFiles(updatedFiles);
    };

    return (
        <div className="flex flex-column gap-2">
            <div className="grid">
                <div className="col-12">
                    <p>{label}</p>
                    {note && <p className="text-sm text-500 mb-2">{note}</p>}
                    <label id={`${name}-label`} htmlFor={name} className="p-component">
                        <div className="p-inputgroup flex-1">
                            <InputText
                                placeholder="Dosya seçin"
                                disabled
                                value={files.length > 0 ? `${files.length} dosya seçildi` : ""}
                            />
                            <div className="p-button p-component p-fileupload-choose">
                                <i className="pi pi-plus"/> {files.length > 0 ? "Daha Fazla Ekle" : "Dosya Yükle"}
                            </div>
                        </div>
                    </label>
                    <input
                        name={name}
                        id={name}
                        type="file"
                        style={{visibility: "hidden"}}
                        ref={refUploadInput}
                        accept={accept}
                        onChange={handleUploadFile}
                        multiple
                    />
                </div>
                {files.length > 0 && (
                    <div className="col-12">
                        <div className="flex flex-column gap-2">
                            {files.map((file, index) => (
                                <Card key={index} className="noshadow">
                                    <div className="flex align-items-center justify-content-between">
                                        <div className="flex align-items-center gap-2">
                                            <i className="pi pi-file" style={{fontSize: '1.5rem'}}></i>
                                            <div>
                                                <div className="font-semibold">{file.name}</div>
                                                <div className="text-sm text-500">
                                                    {(file.size / 1024 / 1024).toFixed(2)} MB
                                                </div>
                                            </div>
                                        </div>
                                        <Button
                                            icon="pi pi-times"
                                            rounded
                                            text
                                            severity="danger"
                                            onClick={() => removeFile(index)}
                                        />
                                    </div>
                                </Card>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MultiFileUploader;
